export const IS_NO_ACCESS = `NoAccess`;
export const IS_NOT_AUTHORIZED = `NotAuthorized`;
export const IS_SUCCESSFUL_ACCESS = `SuccessfulAccess`;
